import React, { useState } from 'react';
import {  Button, Drawer } from 'antd';
import { IoIosClose } from 'react-icons/io';

import CategorySearch from './CategorySearch/CategorySearch';
import {FaClipboardList} from 'react-icons/fa';
import {
  FilterArea,
  CloseDrawer
} from './MobileSearchView.style';

const FilterDrawer = ({ defaultParamHotel, 
  filtre,
  setTitle,
  setLoader,
  setHotelLoaded, 
  page, 
  size, 
  setDiplayLoadMoreBtn, 
  setparamFiltre, 
  setIsCurrentListFromFilter, 
  setIsOffreChecked,
}) => {
  const [state, setState] = useState(false);
  const sidebarHandler = () => {
    setState(!state);
  };
  return (
    <FilterArea>
      <Button style={{marginLeft:"30px"}}
        // className={`hamburg-btn active}`}
        size="large"
          onClick={sidebarHandler}
        >
      <FaClipboardList/>
      </Button>
      <Drawer
        placement="left"
        closable={false}
        onClose={sidebarHandler}
        width="285px"
        className="mobile-side"
        open={state}
      >
        <CloseDrawer>
          <button onClick={sidebarHandler}>
            <IoIosClose />
          </button>
        </CloseDrawer>
        <CategorySearch 
          defaultParamHotel={defaultParamHotel}  
          filtre={filtre} 
          setTitle={setTitle}
          setLoader={setLoader} 
          setHotelLoaded={setHotelLoaded} 
          page={page} 
          size={size} 
          setDiplayLoadMoreBtn={setDiplayLoadMoreBtn}
          setparamFiltre={setparamFiltre}
          setIsCurrentListFromFilter={setIsCurrentListFromFilter}
          setIsOffreChecked={setIsOffreChecked}
        />
      </Drawer>
    </FilterArea>
  );
};

export default FilterDrawer;
